<template>
  <el-table 
    class="my-table-hok_v1" 
    size="mini" 
    :data="tableData" 
    :header-cell-style="{
      background: 'rgb(35, 36, 72)',
      color: 'rgb(188, 189, 212)',
      'font-size': '14px',
      'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
      'font-weight': 'normal'
    }"
    :span-method="cellMerge"
    :fit="false">
    <el-table-column prop="model" label="机型" width="100"></el-table-column>
    <el-table-column prop="quality" label="画质" width="80"></el-table-column>
    <el-table-column prop="frame_rate" label="帧率" width="80">
      <template #default="{row}">{{ row.frame_rate || '--' }}</template>
    </el-table-column>
    
    <el-table-column label="日期" width="140">
      <template #default="scope">
        <span
          :style="
            'margin-left:' +
            (scope.row?.data.level == 0 ? '0px' : '10px')
          "
        >
          {{ scope.row.data?.date
          }}<i
            style="cursor: pointer"
            v-if="scope.row?.data?.level == 0 && scope.row.show"
            @click="expandCheck(scope.row)"
            :class="
              scope.row.check
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></i>
        </span>
        <span
          @click="expandCheckAdd(scope.row)"
          style="color: #70c1f1; cursor: pointer"
          v-if="scope.row.many"
          >(查看更多)</span
        >
      </template>
    </el-table-column>
    <el-table-column prop="branch" label="SVN分支" width="90"></el-table-column>
    <el-table-column prop="svn" label="SVN" width="80">
      <template #default="{row}">{{ row.svn || '--' }}</template>
    </el-table-column>
    <el-table-column prop="scene" label="场景" width="80"></el-table-column>
    <el-table-column label="结论" width="70">
      <template #default="{ row }">
        <span :style="{color: getResultColor(row)}">{{ row.result }}</span>
      </template>
    </el-table-column>

    <!-- 指标列（标准/数值） -->
    <el-table-column
      v-for="metric in metricColumns"
      :key="metric.label"
      :label="metric.label"
    >
      <el-table-column min-width="120">
        <template #header>
          <div>标准</div>
        </template>
        <template #default="{row}">
          <div v-if="isEmpty(row?.standard?.[metric.key]?.abs)">--</div>
          <div v-else style="color: rgb(51, 157, 255);">{{ row?.standard?.[metric.key]?.abs }}</div>
        </template>
      </el-table-column>
      <el-table-column label="数值" width="60">
        <template #default="{row}">
          <span :style="{color: getValueColor(row, metric.key, 'abs')}">{{ row?.[metric.key] ?? '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="差异" width="60">
        <template #default="{row}">
          <span :style="{color: getValueColor(row, metric.key, 'change')}">{{ row?.diff_data?.[metric.key]?.toFixed(2) ?? '--' }}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="内存峰值" prop="peak_memory_swap" width="130">
      <template #header>
        <div>内存峰值</div>
        <div>（Memory+Swap）</div>
      </template>
      <template #default="{row}">
        <span>{{ row.peak_memory_swap ?? '--' }}</span>
      </template>
    </el-table-column>

    <el-table-column label="PerfDog" width="80">
      <template #default="{ row }">
        <a
          v-if="row.perfdogUrl"
          target="_blank"
          style="cursor: pointer; color: rgb(24, 144, 255); text-decoration: none"
          :href="row.perfdogUrl"
        >{{ row.perfdogText || '对比链接' }}</a>
        <span v-else>--</span>
      </template>
    </el-table-column>

    <el-table-column label="SVN链接" width="90">
      <template #default="{ row }">
        <a
          v-if="row.svnUrl && row.svnUrl !== '--'"
          target="_blank"
          style="cursor: pointer; color: rgb(24, 144, 255); text-decoration: none"
          :href="row.svnUrl"
        >SVN链接</a>
        <span v-else>--</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import axios from 'axios'
import { ElMessage } from "element-plus";

export default {
  name: 'ActionTable',
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
    skinId: {
      type: [String, Number],
      default: '',
    },
    // 动作类型（衣橱 61 / 农场 62）
    actionType: {
      type: [String, Number],
      default: '',
    },
    // 表格主数据请求地址
    dataUrl: {
      type: String,
      default: '/report/dimension_action_data/',
    },
    // 「查看更多」分页数据请求地址
    dataMoreUrl: {
      type: String,
      default: '/report/dimension_action_data_more/',
    },
  },

  data() {
    return {
      tableData: [],
      posterRes: {}, // 原始数据，按机型存储
      metricColumns: [
        { label: '平均帧率(帧)(高于)', key: 'avg_fps' },
        { label: 'BigJank(次)(低于)', key: 'big_jank' },
        { label: 'CPU占用率均值(百分比)(低于)', key: 'avg_cpu' },
        { label: '内存峰值(MB)(低于)', key: 'max_pss' },
      ],
    }
  },

  watch: {
    skinId() {
      this.fetchData()
    },
    actionType() {
      this.fetchData()
    },
  },

  methods: {
    isEmpty(val) {
      return val === null || val === undefined
    },

    getChangeVal(row, metric) {
      return row?.standard?.[metric.key]?.change
    },

    getChangeAbs(row, metric) {
      const change = row?.standard?.[metric.key]?.change
      if (change !== null && change !== undefined) {
        return Math.abs(change)
      }
    },

    async fetchData() {
      if (!this.skinId) return
      try {
        this.tableData = []
        const { data } = await axios(this.dataUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
            action_type: this.actionType,
          }
        })
        this.posterRes = {}

        for (const model in data) {
          let entries = Array.isArray(data[model]) ? data[model] : []
          const show = entries.length > 1
          this.posterRes[model] = entries
          entries.forEach((v) => {
            if (v.level == 0) {
              this.tableData.push(this.buildRow(model, v, show))
            }
          })
        }
        this.recomputeMany()
      } catch (e) {
        console.error('dimension_action_data 请求失败', e)
        ElMessage.error('次元动作数据获取失败')
      }
    },

    buildRow(model, v, show) {
      return {
        ...v,
        model,
        quality: v.quality || '',
        data: { date: v.date, level: v.level },
        show: !!show,
        check: true,
        many: false,
        branch: v.custom_version || '--',
        perfdogUrl: v.link || '',
        perfdogText: v.link ? '查看' : '',
        svnUrl: v['svn链接'] || '',
      }
    },

    // 合并单元格（按机型）
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0) return

      const model = row.model
      const rows = this.tableData
      let startIdx = -1
      let count = 0

      for (let i = 0; i < rows.length; i++) {
        if (rows[i].model === model) {
          if (startIdx === -1) startIdx = i
          count++
        }
      }

      if (rowIndex === startIdx && count > 1) {
        return { rowspan: count, colspan: 1 }
      } else if (count > 1) {
        return { rowspan: 0, colspan: 0 }
      }
    },

    // 展开/收起同一日期下的子版本（level 0 / level 1）
    expandCheck(data) {
      data.check = !data.check
      const model = data.model
      if (!data.check) {
        const addData = this.posterRes[model].filter(
          (v) => v.level != 0
        )
        const list = addData.map((v) =>
          this.buildRow(model, v, false)
        )
        const index = this.tableData.findIndex(
          (r) =>
            r.model == model &&
            r.data.date == data.data.date
        )
        if (index !== -1) {
          this.tableData.splice(index + 1, 0, ...list)
        }
      } else {
        this.tableData = this.tableData.filter(
          (r) =>
            !(
              r.model === model &&
              r.data.level === 1
            )
        )
      }
      this.recomputeMany()
    },

    // 日期列「查看更多」——调用 dataMoreUrl
    async expandCheckAdd(data) {
      const model = data.model
      const page = this.tableData.filter((r) => r.model == model).length
      try {
        const { data: moreData } = await axios(this.dataMoreUrl, {
          params: {
            project: this.project,
            skin_id: this.skinId,
            action_type: this.actionType,
            device_name: model,
            page,
          },
        })

        if (moreData && moreData.length > 0) {
          const list = []
          moreData.forEach((v) => {
            this.posterRes[model].push(v)
            list.push(this.buildRow(model, v, false))
          })
          this.insertAfterLastOccurrenceAdd(model, list)
          this.recomputeMany()
        } else {
          ElMessage.error('暂无更多数据')
        }
      } catch (e) {
        console.error('dimension_action_data_more 请求失败', e)
        ElMessage.error('查看更多数据获取失败')
      }
    },

    insertAfterLastOccurrenceAdd(model, newDevice) {
      let lastIndex = -1
      this.tableData.forEach((device, index) => {
        if (device.model === model) {
          lastIndex = index
        }
      })
      if (lastIndex !== -1) {
        this.tableData.splice(lastIndex + 1, 0, ...newDevice)
      } else {
        this.tableData.push(...newDevice)
      }
    },

    // 重新计算每个机型分组的最后一行，标记「查看更多」
    recomputeMany() {
      const occurrenceCount = {}
      const lastOccurrence = {}
      this.tableData.forEach((device, index) => {
        let key = `${device.model}`;

        if (!occurrenceCount[key]) occurrenceCount[key] = 0
        occurrenceCount[key]++
        lastOccurrence[key] = index
      })
      this.tableData.forEach((device, index) => {
        let key = `${device.model}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      })
    },

    getResultColor(row) {
      const result = row.result
      if (result == '达标') {
        return 'rgb(121, 217, 127)'
      } else if (result == '不达标') {
        return 'rgb(255, 76, 55)'
      }
    },

    getValueColor(row, item, key) {
      const color = row?.color?.[item]?.[key]

      if (color == 'green') {
        return 'rgb(121, 217, 127)'
      } else if (color == 'red') {
        return 'rgb(255, 76, 55)'
      } else {
        return ''
      }
    },
  },

  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
.el-table {
  --el-bg-color: transparent;
}

.el-table :deep(th),
.el-table :deep(tr),
.el-table :deep(td),
.el-table :deep(tr:hover),
.el-table :deep(tr:hover td) {
  color: #fff;
  background-color: rgb(34, 37, 41);
  border-bottom: 1px solid #606469;
}

.el-table :deep(tr:hover td) {
  color: #4ed8da;
}

.my-table-hok_v1 :deep(.el-table__row .cell) {
  background: rgb(35, 36, 72);
  color: rgb(188, 189, 212);
  font-size: 14px;
  font-family: "Microsoft YaHei", "Microsoft YaHei-Regular";
}

.el-table :deep(.el-table__body-wrapper) {
  background-color: rgb(34, 37, 41);
}
</style>
